var map = {
	"./add-novo": 84,
	"./add-novo.svg": 84,
	"./arrows": 85,
	"./arrows.svg": 85,
	"./bolinha-azul": 86,
	"./bolinha-azul.svg": 86,
	"./bolinha-cinza": 87,
	"./bolinha-cinza.svg": 87,
	"./bt-entrega-comum": 88,
	"./bt-entrega-comum-clicado": 89,
	"./bt-entrega-comum-clicado.svg": 89,
	"./bt-entrega-comum.svg": 88,
	"./bt-intermunicipal": 90,
	"./bt-intermunicipal-clicdo": 91,
	"./bt-intermunicipal-clicdo.svg": 91,
	"./bt-intermunicipal.svg": 90,
	"./bt-pagar-conta": 92,
	"./bt-pagar-conta-clicado": 93,
	"./bt-pagar-conta-clicado.svg": 93,
	"./bt-pagar-conta.svg": 92,
	"./bt-servico-cartorio": 94,
	"./bt-servico-cartorio.svg": 94,
	"./car": 95,
	"./car.png": 95,
	"./check-box-desmarcado": 96,
	"./check-box-desmarcado.svg": 96,
	"./company": 97,
	"./company.png": 97,
	"./delivery-man": 98,
	"./delivery-man.png": 98,
	"./delivery_Icon_white": 99,
	"./delivery_Icon_white.png": 99,
	"./estrela-amarela": 100,
	"./estrela-amarela.svg": 100,
	"./estrela-borda": 101,
	"./estrela-borda.svg": 101,
	"./ic-arrow-down-branca": 102,
	"./ic-arrow-down-branca.svg": 102,
	"./ic-arrow-up-branca": 103,
	"./ic-arrow-up-branca.svg": 103,
	"./ic-avatar-barra": 48,
	"./ic-avatar-barra.png": 48,
	"./ic-avatar-barra.svg": 203,
	"./ic-caixa-confete": 104,
	"./ic-caixa-confete.svg": 104,
	"./ic-caixa-de-verdade": 105,
	"./ic-caixa-de-verdade.svg": 105,
	"./ic-caixa-menu": 106,
	"./ic-caixa-menu.svg": 106,
	"./ic-chat-branco": 107,
	"./ic-chat-branco.svg": 107,
	"./ic-checked": 49,
	"./ic-checked.png": 49,
	"./ic-checked.svg": 204,
	"./ic-clock-azul": 108,
	"./ic-clock-azul.svg": 108,
	"./ic-diversos-menu": 109,
	"./ic-diversos-menu.svg": 109,
	"./ic-entrega": 110,
	"./ic-entrega.png": 110,
	"./ic-esqueci-a-senha": 111,
	"./ic-esqueci-a-senha.svg": 111,
	"./ic-financeiro-menu": 112,
	"./ic-financeiro-menu.svg": 112,
	"./ic-lista-caminho": 113,
	"./ic-lista-caminho.svg": 113,
	"./ic-logo-barra-preta": 114,
	"./ic-logo-barra-preta.svg": 114,
	"./ic-loja": 115,
	"./ic-loja.png": 115,
	"./ic-lupa-busca": 116,
	"./ic-lupa-busca-cinza": 117,
	"./ic-lupa-busca-cinza.svg": 117,
	"./ic-lupa-busca.svg": 116,
	"./ic-mail-cinza": 118,
	"./ic-mail-cinza.svg": 118,
	"./ic-meajude-menu": 119,
	"./ic-meajude-menu.svg": 119,
	"./ic-people-menu": 120,
	"./ic-people-menu.svg": 120,
	"./ic-pin-azul": 50,
	"./ic-pin-azul.png": 50,
	"./ic-pin-azul.svg": 205,
	"./ic-pin-blue-fullfiled": 121,
	"./ic-pin-blue-fullfiled.svg": 121,
	"./ic-pin-deliverer": 122,
	"./ic-pin-deliverer.svg": 122,
	"./ic-pin-gray-fullfiled": 123,
	"./ic-pin-gray-fullfiled.svg": 123,
	"./ic-pin-green-fullfiled": 124,
	"./ic-pin-green-fullfiled.svg": 124,
	"./ic-pin-red-fullfiled": 125,
	"./ic-pin-red-fullfiled.svg": 125,
	"./ic-remove-destino": 126,
	"./ic-remove-destino.svg": 126,
	"./ic-remove-verde": 127,
	"./ic-remove-verde.svg": 127,
	"./ic-sacola": 128,
	"./ic-sacola.svg": 128,
	"./ic-search": 129,
	"./ic-search.svg": 129,
	"./ic-servico-cartorio-clicado": 130,
	"./ic-servico-cartorio-clicado.svg": 130,
	"./ic-seta-direita": 131,
	"./ic-seta-direita.svg": 131,
	"./ic-seta-esquerda": 132,
	"./ic-seta-esquerda.svg": 132,
	"./ic-whatsapp": 133,
	"./ic-whatsapp.svg": 133,
	"./integration_logo_focco_delivery": 134,
	"./integration_logo_focco_delivery.svg": 134,
	"./integration_logo_focco_delivery_dark": 135,
	"./integration_logo_focco_delivery_dark.svg": 135,
	"./loading": 136,
	"./loading.gif": 136,
	"./logo-compact-white": 137,
	"./logo-compact-white.png": 137,
	"./logo-dark": 138,
	"./logo-dark.svg": 138,
	"./logo-full-white": 139,
	"./logo-full-white.png": 139,
	"./logo_pequeno_levoo": 140,
	"./logo_pequeno_levoo.png": 140,
	"./lorry": 141,
	"./lorry.png": 141,
	"./motorcycle": 142,
	"./motorcycle.png": 142,
	"./new-favicon-16x16.ico": 206,
	"./person": 143,
	"./person.png": 143,
	"./safari-pinned-tab": 144,
	"./safari-pinned-tab.svg": 144,
	"./send-button": 145,
	"./send-button.svg": 145,
	"./seta-azul-baixo": 146,
	"./seta-azul-baixo.svg": 146,
	"./seta-azul-cima": 147,
	"./seta-azul-cima.svg": 147,
	"./seta-ordenar": 148,
	"./seta-ordenar.svg": 148,
	"./setinha-baixo": 149,
	"./setinha-baixo.svg": 149,
	"./small_stars": 150,
	"./small_stars.svg": 150,
	"./upload": 151,
	"./upload.svg": 151,
	"./van": 152,
	"./van.png": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 202;